var React = require('react');

function Seedling (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 32c0 115.9-88 211.1-200.7 222.8a256.38 256.38 0 0 0-59-107.6C290.6 78.5 363.8 32 448 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 320v144a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320C100.3 320 0 219.7 0 96h64c123.7 0 224 100.3 224 224z","className":"fa-primary","key":2})]);
}

Seedling.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Seedling;

Seedling.default = Seedling;
